import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { brokerCasesApi } from 'api/brokerCases';
import type { BrokerCasesTasksResponse } from 'api/brokerCases/types';

export const CASE_TASKS_QUERY_KEY = 'broker-case-tasks';

export function useCaseTasks(caseId?: string | number): UseQueryResult<BrokerCasesTasksResponse> {
  const isMigrated = typeof caseId === 'string';

  return useQuery({
    queryKey: [CASE_TASKS_QUERY_KEY, caseId],
    queryFn: () => (isMigrated ? brokerCasesApi.getTasks(caseId) : null),
    enabled: isMigrated,
    retry: false,
    refetchOnWindowFocus: false,
    refetchInterval: 2500,
  });
}
